import React from "react";
import "../../css/Hero.css";

const renderLines = (text) => {
  const lines = text.split("\n");

  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));
};
function Hero({
  title = "MORTGAGE SPECIALIST\nFOR YOU",
  subtitle = "",
  backgroundImage = "",
  titleAlign = "center", // "center" | "left"
  subtitleAlign = "center", // "center" | "left"
}) {
  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="hero-overlay">
        <div className="hero-content">
          <h1 className="font-hero-title" style={{ textAlign: titleAlign }}>
            {renderLines(title)}
          </h1>

          <div className={`divider align-${titleAlign}`}></div>

          <p style={{ textAlign: subtitleAlign }}>{renderLines(subtitle)}</p>
        </div>
      </div>
    </section>
  );
}


export default Hero;
